import React from 'react';
import styles from './Card.module.css';
import Skeleton from "@/components/Skeleton/Skeleton";
import Divider from '../Divider/Divider';
import { Link } from 'wouter';

const Card = ({ label, productName, value, isLoading, href='', imageUrl='',  }) => {
    const disabled = !href;

    return (
        <div className={styles.card}>
            <div className={styles.label}>{label}</div>

            <div className={styles.titleValue}>
                {(isLoading && imageUrl) ? <Skeleton type={'image'}/> : imageUrl ? <img src={imageUrl} alt={productName} className={styles.image} /> : <></>}
                {isLoading ? <Skeleton /> : <div className={styles.productNameSmall}>{productName}</div>}
                {isLoading ? <Skeleton /> : <div className={styles.value}>{value}</div>}
            </div>
            <Divider />
            <div>
                <Link
                    href={disabled ? undefined : href}
                    className={`${styles.link} ${disabled ? styles.disabled : ''}`}
                    onClick={disabled ? (e) => e.preventDefault() : undefined}
                >
                    View details
                </Link>
            </div>
        </div>
    )
}

export const TotalCard = ({ label, value, isLoading, subHeading }) => {
    return (
        <div className={styles.card}>
            <div className={styles.label}>{label}</div>

            <div className={styles.totalTitleValue}>
                {isLoading ? <Skeleton /> : <div className={styles.totalValue}>{value}</div>}
                {isLoading ? <Skeleton /> : <div className={styles.totalSubHeading}>{subHeading}</div>}
            </div>
            <Divider />
            <div>
                <Link
                    href={undefined}
                    className={`${styles.link} ${styles.disabled}`}
                    onClick={(e) => e.preventDefault()}
                >
                    View details
                </Link>
            </div>
        </div>
    )
}

export default Card;